module.exports = __webpack_public_path__ + "img/QR-3799.8e36e5ff.png";